import { crudActions } from "./CrudActions"

export default {
  ...crudActions("users"),
}
